export default "__VITE_ASSET__EaP3Jhqp__"